import React, {useContext, useEffect, useState} from "react";

import {OrderContext} from "../../context/OrderContext";
import {UserContext} from '../../context/UserContext';

import {APIPostOrderLinkedMessaging} from "../../api/orders/OrdersMessaging";
import {APIArchiveOrderTender} from "../../api/orders/OrdersTender";

export const OrderTenderAction = () => {
    const {order, saveOrder, setShowBidModal} = useContext(OrderContext);
    const { user } = useContext(UserContext);
    const [ message, setMessage ] = useState(null);
    const [ buttonText, setButtonText ] = useState(null);

    const updateOrder = async () => {
        const messageData = {
            ordersId : order?.id,
            linkId : order?.id,
            linkType : "progressUpdate",
            createdByUser : user?.id,
            createdByUserName : user?.name,
            createdByCompany : user?.companyId,
            createdByCompanyName : user?.companyId,
            message,
            orderCompanyUser: user?.companyId === order?.createdByCompany ? null : order?.createdByUser,
            orderCompany: order?.createdByCompany,
            contractedCompany: order?.contractedCompany,
            planId: order?.planId,
        }
        
        const promises = [];

        if (order?.stage === "inTender") {
            promises.push(APIArchiveOrderTender({orderId: order?.id, companyId: user.companyId}));
            promises.push(saveOrder("draft"));
        } else {
            setShowBidModal(true);
        }

        promises.push(APIPostOrderLinkedMessaging({messageData, companyId: user?.companyId}));
        await Promise.all(promises);
    }

    useEffect(() => {
        if (order?.stage === "inTender") {
            setMessage("Angebote einholen wurde Vorzeitig beendet");
            setButtonText("Angebote einholen beenden");
        } else if (order?.stage === "draft"){
            setMessage("Angebote einholen für den Auftrag wurde gestartet");
            setButtonText("Angebote einholen starten");
        }
    }, [order?.stage]);


    return (buttonText === null) ? null : (
        <button onClick={updateOrder} type="button" className="whitespace-nowrap my-2 sm:my-0 border w-full sm:w-auto border-gray-900 block sm:border-0 items-center rounded-md bg-gray-900 text-white px-4 py-2 text-sm font-semibold ring-inset hover:bg-gray-50">
            {buttonText}
        </button>
    )
}